import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/atoms/Button';
import { Tag } from '../ui/atoms/Tag';

interface AIToolsSetupPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const AIToolsSetupPopup: React.FC<AIToolsSetupPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            🤖 AI Tools Required
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-100 rounded-lg p-3">
            <p className="text-gray-700 text-sm">
              This question requires you to use AI tools alongside your code editor. 
              Please set up your preferred AI assistant before proceeding.
            </p>
          </div>

          <div>
            <h4 className="font-medium text-gray-900 mb-2">Recommended Tools:</h4>
            <div className="flex flex-wrap gap-2">
              <Tag intent="info" variant="subtle">Cursor</Tag>
              <Tag intent="success" variant="subtle">ChatGPT</Tag>
              <Tag intent="primary" variant="subtle">Claude</Tag>
              <Tag intent="warning" variant="subtle">GitHub Copilot</Tag>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
            <h4 className="font-medium text-gray-900 mb-2">Steps:</h4>
            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
              <li>Open your preferred AI tool in a separate window/tab on the same screen that is being shared</li>
              <li>Ensure you can use it alongside this interview interface</li>
              <li>Click "Ready" when your AI tools are set up</li>
            </ol>
          </div>

          <div className="bg-amber-50 border border-amber-100 rounded-lg p-3">
            <p className="text-gray-700 text-sm">
              <strong>Important:</strong> Explain your thought process and how you're integrating AI tools into your solution.
            </p>
          </div>
        </div>

        <div className="flex justify-center pt-3">
          <div className="w-full [&>div]:w-full">
            <Button
              onClick={onConfirm}
              label="Ready"
              type="contained"
              intent="secondary"
              className='w-full'
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
